export default __webpack_public_path__ + "static/media/login-frame.c67136dc.jpg";